export default "<template>\n\n  <KTextbox label=\"Label via prop\" />\n\n</template>\n";